/**
 * 打印完 待发货
 */

<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>待发货</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
     <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.filename" placeholder="文件名称"></el-input>
      </el-form-item>
      <el-form-item>
             <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" icon="el-icon-setting" @click="againcompose()">重新合成</el-button>
        <el-button size="small" type="danger" icon="el-icon-upload2" @click="delivery()">发货</el-button>
        <el-button size="small" type="warning" icon="el-icon-tickets" @click="printExcel()">生成Excel</el-button>
        <el-button size="small" type="info" icon="el-icon-tickets" @click="printLable()">生成标签</el-button>

      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small"  @selection-change="selectChange" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="80px">
      </el-table-column>
      <el-table-column align="center"  prop="filename" label="合成文件名称"  width="500">

        <div slot-scope="scope"  >
          {{scope.row.filename}}
        </div>
      </el-table-column>
      <el-table-column align="center"  prop="createtime" label="合成时间" >
        <div slot-scope="scope" >
  				    	{{scope.row.createtime|timestampToTime}}
        </div>
      </el-table-column>
      <el-table-column  align="center" prop="forwardtime" label="接收时间">
        <div slot-scope="scope"  >
          {{scope.row.forwardtime|timestampToTime}}
        </div>
      </el-table-column>
<!--      <el-table-column  align="center" prop="latesttime" label="最晚时间" >-->
<!--        <div slot-scope="scope" >-->
<!--          {{scope.row.latesttime|timestampToTime}}-->
<!--        </div>-->
<!--      </el-table-column>-->
<!--      <el-table-column  align="center" prop="spenttime" label="距最晚发货时间">-->
<!--        <div slot-scope="scope" >-->
<!--          {{scope.row.spenttime}}-->
<!--        </div>-->
<!--      </el-table-column>-->
<!--      <el-table-column align="center"  prop="times" label="合成次数" >-->

<!--        <div slot-scope="scope"  >-->
<!--          {{scope.row.times}}-->
<!--        </div>-->
<!--      </el-table-column>-->
      <el-table-column  align="center" prop="status" label="订单状态">
        <fileStatus slot-scope="scope" >
          {{scope.row.status|FileStatus}}
        </fileStatus>
      </el-table-column>

<!--      <el-table-column align="center" label="操作" min-width="150">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
<!--          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :visible.sync="dialogVisible" @close="dislogClosed">

      <p>提示</p>
      <p>生成通知已发送到本地服务器,请到本地服务器查看PDF/EXCEL生成情况,切勿重复操作!!! </p>
      <span slot="footer" class="dialog-footer">
     <el-button @click="dialogVisible = false">关闭</el-button>
     </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  WaitDelivery,createLableFile,
  delivery,createExcel,againCompose
} from '../../api/ordersMG'
import Pagination from '../../components/Pagination'
export default {
  name: "orders",
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      dialogVisible:false,
      formInline: {
        filename:"",
        pageNum: 1,
        pageSize: 10
      },
      // 选择数据
      selectdata: [],
      listData: [], //用户数据

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取订单列表
    getdata(parameter) {
      this.loading = true


      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      WaitDelivery(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.pageNum
            this.pageparm.pageSize = this.formInline.pageSize
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('数据加载失败，请稍后再试！')
        })

    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    delivery(){

      let parms = {
        pdfNames: ''
      }
      let len = this.selectdata
      if(len==0)
      {
        this.$message({
          type: 'warning',
          message: "请选择需要待发货数据"
        })
        return
      }
      let pdfNames = []
      if (len != 0) {
        for (let i = 0; i < len.length; i++) {
          pdfNames.push(len[i].filename)
        }
      }
      parms.pdfNames = pdfNames.join(',')
      this.loading = true
      delivery(parms)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'warning',
              message: res.msg
            })
            this.loading = false
          } else {
            this.search();
            this.$message({
              type: 'info',
              message: "操作成功"
            })
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('未知错误！')
        })


    },
    againcompose(){

      let parms = {
        pdfNames: ''
      }
      let len = this.selectdata
      if(len==0)
      {
        this.$message({
          type: 'warning',
          message: "请选择需要重新生成的pdf"
        })
        return
      }
      let pdfNames = []
      if (len != 0) {
        for (let i = 0; i < len.length; i++) {
          pdfNames.push(len[i].filename)
        }
      }
      parms.pdfNames = pdfNames.join(',')
      this.loading = true
      againCompose(parms)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'warning',
              message: res.msg
            })
            this.loading = false
          } else {
            this.search();
            this.dialogVisible=true;
            // this.$message({
            //   type: 'info',
            //   message: "生成通知已发送到本地服务器,请注意查看pdf生成情况。 pdf正在生成时，请不要再做其他生成操作，切记！！！"
            // })
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('未知错误！')
        })


    },
    printLable(){

      let parms = {
        pdfNames: ''
      }
      let len = this.selectdata
      if(len==0)
      {
        this.$message({
          type: 'warning',
          message: "请选择需要生成标签的pdf"
        })
        return
      }
      let pdfNames = []
      if (len != 0) {
        for (let i = 0; i < len.length; i++) {
          pdfNames.push(len[i].filename)
        }
      }
      parms.pdfNames = pdfNames.join(',')
      this.loading = true

      createLableFile(parms)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'warning',
              message: res.msg
            })
            this.loading = false
          } else {
           // this.search();
            this.dialogVisible=true;
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('未知错误！')
        })


    },
    printExcel(){
    this.loading = true
      createExcel()
      .then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({
            type: 'warning',
            message: res.msg
          })
          this.loading = false
        } else {
          this.dialogVisible=true;
          // this.$message({
          //   type: 'info',
          //   message: "生成通知已发送到本地服务器,请注意查看excel生成情况。"
          // })
          this.loading = false
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('未知错误！')
      })


  },
    stautsFormat(row, column) {

      if (row.status === 0) {
        return '待发货'
      }else if (row.status === 2) {
        return '已发货'
      }
    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/orders/WaitDelivery.vue